import { Button, Form, FormProps, Input, Space } from 'antd';
import React, { memo } from 'react';
import classnames from 'classnames';
import { PlusOutlined } from '@ant-design/icons';
import ImgUpload from '@/components/ImgUpload';
import styles from './index.module.scss';

const { TextArea } = Input;

export type CoreTeamFormValueType = {
  avatarUrl?: string;
  memberName?: string;
  memberJob?: string;
  memberDesc?: string;
};
export type CoreTeamAbilityFormTeamFormValueType = {
  brandGroupList: CoreTeamFormValueType[];
};
export type CoreTeamAbilityFormProps = {
  form?: FormProps<CoreTeamAbilityFormTeamFormValueType>['form'];
};
const CoreTeamAbilityForm: React.FC<CoreTeamAbilityFormProps> = ({ form }) => {
  const initialValue = {
    brandGroupList: [
      { avatarUrl: '', memberName: '', memberJob: '', memberDesc: '' },
      { avatarUrl: '', memberName: '', memberJob: '', memberDesc: '' },
      { avatarUrl: '', memberName: '', memberJob: '', memberDesc: '' },
      { avatarUrl: '', memberName: '', memberJob: '', memberDesc: '' },
    ],
  };
  return (
    <Form<CoreTeamAbilityFormTeamFormValueType>
      initialValues={initialValue}
      size="large"
      form={form}
      autoComplete="off"
    >
      <Form.List name="brandGroupList">
        {(fields, { add, remove }) => {
          return (
            <>
              <Form.Item>
                <Button
                  className={styles.addBtn}
                  type="primary"
                  size="middle"
                  icon={<PlusOutlined />}
                  onClick={() => add()}
                >
                  添加更多核心团队信息
                </Button>
              </Form.Item>
              <Space size={[24, 16]} wrap>
                {fields.map(({ key, name, ...restField }, index) => {
                  return (
                    <div key={key} className={styles.formCard}>
                      {!!index && (
                        <svg
                          className={classnames('icon', styles.removeIcon)}
                          aria-hidden="true"
                          onClick={() => remove(name)}
                        >
                          <use xlinkHref="#icon-clear-copy" />
                        </svg>
                      )}
                      <Space key={key} direction="vertical" className={styles.space}>
                        <Form.Item
                          {...restField}
                          className={styles.uploadFormItem}
                          name={[name, 'avatarUrl']}
                          label="人员头像"
                        >
                          <ImgUpload listType="picture-card" maxCount={1} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          className={styles.formItem}
                          name={[name, 'memberName']}
                          label="人员名称"
                        >
                          <Input className={styles.input} placeholder="请输入核心团队人员名称" />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          className={styles.formItem}
                          name={[name, 'memberJob']}
                          label="人员职务"
                        >
                          <Input className={styles.input} placeholder="请输入核心团队人员职务" />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          className={styles.formItem}
                          name={[name, 'memberDesc']}
                          label="人员简介"
                        >
                          <TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
                        </Form.Item>
                      </Space>
                    </div>
                  );
                })}
              </Space>
            </>
          );
        }}
      </Form.List>
    </Form>
  );
};

export default memo(CoreTeamAbilityForm);
